module.exports = __webpack_public_path__ + "static/contact-me-prompt-d8fd2d8ff6c60112182a3ad44d2e9357.png";